import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ element }) => {
  const isAuthenticated = !!localStorage.getItem("token"); // Check if token exists
  const userLoggedInDetails = JSON.parse(localStorage.getItem("userLoggedInDetails"));

  // Extract the roles (assuming it's an array)
  const userRoles = userLoggedInDetails?.staffRoles?.map(role => role.permissionName) || [];

  // console.log("🚀 ~ PrivateRoute ~ userRoles:", userRoles);

  // List of restricted roles
  const restrictedRoles = ["Support Worker", "Senior Support Worker", "Support Worker (Office)", "Teaching Assistant"];

  // Check if any of the user's roles are in the restrictedRoles list
  if (userRoles.some(role => restrictedRoles.includes(role))) {
    return <Navigate to="/restricted-web-access" />;
  }

  return isAuthenticated ? element : <Navigate to="/" />;
};

export default PrivateRoute;
